import { render, staticRenderFns } from "./TransformTable.vue?vue&type=template&id=2d64899e&scoped=true&"
import script from "./TransformTable.vue?vue&type=script&lang=js&"
export * from "./TransformTable.vue?vue&type=script&lang=js&"
import style0 from "./TransformTable.vue?vue&type=style&index=0&id=2d64899e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d64899e",
  null
  
)

export default component.exports